module.exports = __webpack_public_path__ + "static/img/shop9.2b35776.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop9.png
// module id = 3sFv
// module chunks = 2